import { connect } from "react-redux";
import DanhSachNhanVien from "components/DanhSachNhanVien";
import { getListDanhSachNhanVien } from "actions/DanhSachNhanVien";

const mapStateToProps = (state) => ({
  danhsachnhanvien: state.danhsachnhanvien,
  user: state.user,
});

const mapDispatchToProps = (dispatch) => ({
  getListDanhSachNhanVien: (dataSearch) =>
    dispatch(getListDanhSachNhanVien(dataSearch)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DanhSachNhanVien);
